const images = [
  {
    src: "/Country/polandia.jpg",
    name: "Poland",
    description:
      "Poland is known for Warsaw, a modern city rich in history. It is an attractive destination for migrant workers in the manufacturing and logistics sectors.",
  },
  {
    src: "/Country/ceko.jpg",
    name: "Czech Republic",
    description:
      "The Czech Republic, with its capital Prague, is a hub of industry and tourism. Many Indonesian migrant workers are employed in factories and the service sector here.",
  },
  {
    src: "/Country/jepang.jpg",
    name: "Japan",
    description:
      "Japan is known for its advanced technology and disciplined work culture. The country recruits many foreign workers through internship programs.",
  },
  {
    src: "/Country/arab.jpg",
    name: "Saudi Arabia",
    description:
      "Saudi Arabia is a popular destination for domestic workers and the construction sector, offering a different work culture and competitive wages.",
  },
  {
    src: "/Country/taiwan.jpg",
    name: "Taiwan",
    description:
      "Taiwan offers job opportunities in factories, elderly care, and domestic work. It is known for its comfortable living conditions and decent wages.",
  },
  {
    src: "/Country/singapura.jpg",
    name: "Singapore",
    description:
      "Singapore is known as a financial and business center in Southeast Asia. It offers employment opportunities in the domestic, construction, and service sectors. With a structured work system and multicultural environment, Singapore is an appealing choice for Indonesian migrant workers.",
  },
  {
    src: "/Country/koreaselatan.jpg",
    name: "South Korea",
    description:
      "Korea, or more commonly known as South Korea, is a country in East Asia that is famous for its technological advancement, pop culture, and strong traditions. Its capital city is Seoul, one of the largest and most modern metropolitan cities in the world. The country has a unique blend of fast-paced modern life and well-preserved traditions such as the hanbok, hanok (traditional houses), and various cultural festivals.",
  },
];

export default images;
